import React, { useState } from 'react';
import { connect, getLocale } from 'umi';
import Competitive from '../components/Competitive';
import Filter from '@/pages/dashboard/filterPageComponents/competitor/insightFilterNew';

import { useBuriedPoint } from "@/pages/home/utils/customHook";
import '@/pages/dashboard/assets/scss/page/competitor/insight.scss';
import MarqueeInfo from "@/pages/dashboard/components/MarqueeInfo";

const Insight = (props: any) => {
  const { 
    gameCode, 
    competitorReqType,
    urlReqType = "index"
  } = props;

  const [filterValue, setFilterValue] = useState({} as any);
  const [filterLoading, setFilterLoading] = useState(true);

  const handleInit = (filterValue: any) => {
    setFilterValue(filterValue);
    setFilterLoading(false);
  }

  const handleFilterSave = (filterValue: any) => {
    setFilterValue(filterValue)
  }

    // 打点信息
    const logObj = {
      pageId: competitorReqType === 'xh' ? '204002' : '201302',
      pageName: competitorReqType === 'xh' ? 'competitorInsightXh' : 'competitorInsight',
      extInfo: competitorReqType === 'xh' ? 'competitorInsightXh' : 'competitorInsight',
      pagePath: `/competitor/${urlReqType}/insight`,
      uid: gameCode,
      typeId: 'dashboard_pc_v2',
    }
    useBuriedPoint(logObj);
  
  return (
    <div className="dbd-insight">
      <MarqueeInfo pagePath={logObj.pagePath}/>
      <Filter
        openSticky={true}
        filterConfirm={handleFilterSave}
        filterReset={handleFilterSave}
        filterInit={handleInit}
        competitorReqType={competitorReqType}
        buttonLogConfig={{ pageId: logObj.pageId, confirmButtonId: logObj.pageId + '001', resetButtonId: logObj.pageId + '002' }}
      />
      <Competitive
        gameCode={gameCode}
        filterLoading={filterLoading}
        formValue={filterValue}
        competitorReqType={competitorReqType}
      />
    </div>
  );
};

export default connect((state: any) => {
  return {
    serviceData: state.overview?.data,
    gameCode: state.dashboard?.currentGame?.game_code,
  };
})(Insight);
